import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal
} from '@angular/core';
import { TranslationService } from '@core';
import { SzSegmentedComponent, SzSegmentedOption } from '@ui';

export type DrillsListTypeFilter = 'all' | 'dry' | 'live';

@Component({
  selector: 'lib-drills-list-type-filter',
  templateUrl: './drills-list-type-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzSegmentedComponent]
})
export class DrillsListTypeFilterComponent {
  readonly active: InputSignal<DrillsListTypeFilter> = input.required<DrillsListTypeFilter>();
  readonly activeChange: OutputEmitterRef<DrillsListTypeFilter> = output<DrillsListTypeFilter>();

  private readonly translation: TranslationService = inject(TranslationService);

  readonly options: Signal<ReadonlyArray<SzSegmentedOption<DrillsListTypeFilter>>> = computed(() => {
    this.translation.translationsLoaded();
    return [
      { label: this.translation.translate('common.drillType.all'), value: 'all' as DrillsListTypeFilter },
      { label: this.translation.translate('common.drillType.dry'), value: 'dry' as DrillsListTypeFilter },
      { label: this.translation.translate('common.drillType.live'), value: 'live' as DrillsListTypeFilter }
    ];
  });

  onValueChange(value: DrillsListTypeFilter): void {
    this.activeChange.emit(value);
  }
}
